import { render, staticRenderFns } from "./NotaryProductDetails.vue?vue&type=template&id=f81af8c4&"
import script from "./NotaryProductDetails.vue?vue&type=script&lang=ts&"
export * from "./NotaryProductDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports